<template>
  <div class="col-md-3">
    <form-group-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="options"
      :data-vv-as="label"
      placeholder="Selecione"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
      />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: 'new'
  },
  inject: ['$validator'],
  name: 'c-recebimento-boleto',
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  data() {
    return {
      options: [
        { text: 'Impresso', value: 'Impresso' },
        { text: 'E-mail', value: 'E-mail' },
        { text: 'SMS', value: 'SMS' }
      ]
    };
  },
  computed: {
    usuario() {
      return this.$store.state.usuario;
    }    
  },
  mounted() {
    this.$el.value = this.value;
    if (this.usuario.tipo === 1 || this.usuario.tipo === 14) {
      this.options = [
        { text: 'Portal', value: 'Portal' }
      ]
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/RecebimentoBoleto.vue